import { render, staticRenderFns } from "./EstatusIncidencias.vue?vue&type=template&id=6081a860"
import script from "./EstatusIncidencias.vue?vue&type=script&lang=js"
export * from "./EstatusIncidencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports